import { createReducer, on, Action } from '@ngrx/store';
import { addToCarPlan,removePlanFromCar,modifyTokenPlan } from '../actions/carPlanCheckout.actions';
import { Plan } from '../../models/plan.model';


export const initialState: Plan[] = [];

const _carPlanCheckoutReducer = createReducer(initialState,
  on( addToCarPlan, (state, { plan }) => [...state, plan ] ),
  on ( removePlanFromCar, ( state, {​​​​​​​​ id }​​​​​​​​ ) =>state.filter( product=>product.id !== id ) ),
  on( modifyTokenPlan, (state, { id, token }) => {
    return state.map( plan => {
      if ( plan.id === id  ) {
        return {
          ...plan,
          token
        }
      } else {
        return plan;
      }
    });
  }),
);


export function carPlanCheckoutReducer(state: Plan[] | undefined, action: Action) {
    return _carPlanCheckoutReducer(state, action);
}
